import React, { useState } from 'react';
import { useIdleTimer } from 'react-idle-timer';
import DialogConfirm from './DialogConfirm';
import { logout } from "@store/user";
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from "react-router-dom";

let countdownInterval;
let timeout;


const SessionTimeout = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    const { user } = useSelector(state => state.user);

    const [state, setState] = useState({
        timeoutModalOpen: false,
        timeoutCountdown: 0,
    })

    const clearDialogTimeout = () => {
        clearTimeout(timeout);
    };

    const clearDialogInterval = () => {
        clearInterval(countdownInterval);
    };

    const onActive = () => {
        if (state.timeoutModalOpen) return;
        clearDialogTimeout();
        clearDialogInterval();
    }

    const onContinue = () => {
        setState(prevState => ({ ...prevState, timeoutModalOpen: false }));
        clearDialogTimeout();
        clearDialogInterval();
    }

    const signout = () => {
        try {
            setState(prevState => ({ ...prevState, timeoutModalOpen: false }))
            dispatch(logout());
            clearDialogTimeout();
            clearDialogInterval();
            history.push('/');
        } catch (err) {
            console.error(err);
        }

    }

    const onIdle = () => {
        if (state.timeoutModalOpen) return;
        timeout = setTimeout(() => {
            let timeoutCountdown = 120;
            setState(prevState => ({ ...prevState, timeoutModalOpen: true, timeoutCountdown: timeoutCountdown }))
            countdownInterval = setInterval(() => {
                timeoutCountdown -= 1;
                if (timeoutCountdown > 0) setState(prevState => ({ ...prevState, timeoutCountdown }))
                else if (timeoutCountdown === 0) signout();
            }, 1000);
        }, 1000);
    }

    const { reset, pause } = useIdleTimer({
        timeout: 1000 * 60 * 28,
        onActive,
        onIdle,
        debounce: 250
    });

    React.useEffect(() => {
        if (!!user) reset();
        else pause();
    }, [user]);

    return <DialogConfirm
        {...{
            dialogProps: {
                open: state.timeoutModalOpen,
            },
            okBtnText: 'Continue',
            cancelBtnText: 'Logout',
            content: `Your session will logout in ${state.timeoutCountdown > 0 ? state.timeoutCountdown : 0} seconds.`,
            onOkClickHandler: onContinue,
            onCancelClickHandler: signout
        }}
    />

}

export default SessionTimeout;